import React, { Fragment } from 'react';
import { Link } from '@material-ui/core';

export const getTextById = (id) => FAQS.find( faq => faq.id === id );

const isCoschedulingEnabled = document.documentElement.dataset.isCoschedulingEnabled === 'true';
export const FAQS = [
  {
    q: 'What’s Included?',
    id: 'included',
    a: () =>
      <Fragment>
        <p>
          The technician will perform a general inspection of your heating or cooling system.
          If additional work is required to return your system to normal, the technician will inform you.
          You will have the opportunity to approve or decline all additional services.
        </p>
      </Fragment>
  },
  {
    q: 'What does preferred date and time mean?',
    id: 'coscheduling',
    a: () =>
      <Fragment>
        <p>Handy will endeavor to send a pro at your preferred date and time. If a HVAC Technician can not make that time, they will <b>call</b> you directly to schedule an appointment that is mutually agreed upon to accommodate your schedule.</p>
      </Fragment>,
    hide: !isCoschedulingEnabled
  },
  {
    q: 'Will the professional bring their own tools?',
    id: 'tools',
    a: () =>
      <Fragment>
        <p>Your professional will come with all required tools for your job, however if there’s something in particular you’re unsure of or just want to check on, <Link rel="noopener noreferrer" target="_blank" href="https://handy.app.link/app">download the app</Link> and message your pro ahead of time to make sure they’re prepared!</p>
      </Fragment>
  },
  {
    q: 'Who is coming to my booking?',
    id: 'pro',
    a: () =>
      <Fragment>
        <p>Handy has a vast network of experienced, top-rated professionals. Based on the time and date of your request, we work to assign the best professional available.</p>
        <p>You will receive an email with details about your professional prior to your appointment.</p>
      </Fragment>
  },
  {
    q: 'What happens if something goes wrong?',
    id: 'wrong',
    a: () =>
      <Fragment>
        <p>When you Book with Handy, your happiness is our goal.  If you’re not happy, we’ll work to make it right.</p>
        <p>See details about the <Link rel="noopener noreferrer" target="_blank" href="https://www.handy.com/handy-guarantee">Handy Happiness Guarantee</Link> here.</p>
      </Fragment>
  },
  {
    q: 'Can I reschedule or cancel my booking?',
    id: 'cancel',
    a: () =>
      <Fragment>
        <p>Absolutely! You can reschedule and manage all of your booking details through the <Link rel="noopener noreferrer" target="_blank" href="https://handy.app.link/app">Handy app</Link>. You can also manage your account on <Link rel="noopener noreferrer" target="_blank" href="https://handy.com">Handy.com</Link>.</p>
        <p>To reschedule on the web:</p>
        <ul>
          <li>Visit <Link rel="noopener noreferrer" target="_blank" href="https://handy.com">www.handy.com</Link>.</li>
          <li>Go to the bookings page on your account.</li>
          <li>Click the edit booking drop down.</li>
          <li>Select &apos;Reschedule Booking&apos;</li>
          <li>Choose the date and time you’d like to move the booking to.</li>
          <li>Click the &apos;Reschedule&apos; button.</li>
        </ul>
      </Fragment>
  },
  {
    q: 'I need more help.',
    id: 'help',
    a: () =>
      <Fragment>
        <p><Link rel="noopener noreferrer" target="_blank" href="https://help.handy.com/hc/en-us">Need more help?</Link></p>
      </Fragment>
  },
];
